<div class="container-fluid">
  <div class="col-sm-11 mx-auto d-flex pb-5">
    <div class="row">
      <div *ngIf="loggedIn">
        <app-dashboard [user]="user" [customer]="customer" #dashboard></app-dashboard>
      </div>
    </div>
  </div>
</div>
